import { isStaffType } from '@/enums/merchant-type.enum'
import { dateFormat } from '@/filters/index.js'

class UsersManager {
  data = []

  constructor (accountId, data) {
    if (!accountId) throw new Error('Missing argument account id!')

    this.accountId = accountId
    this.data = data
  }

  /**
   *
   * @param {*} user
   * @param {*} account
   * @returns
   */
  getPermission (user, account) {
    return isStaffType(user.merchant.type.key)
      ? account.role.value
      : user.merchant.type.value
  }

  /**
   *
   * @param {*} user
   * @returns
   */
  getAccount (user) {
    return user.merchant.accounts.find(account => account.id === this.accountId)
  }

  /**
   *
   * @param {*} user
   * @returns
   */
  convertToView (user) {
    const {
      id,
      first_name,
      last_name,
      email,
      phone,
      document_number: documentNumber,
      merchant,
      created_at,
      updated_at
    } = user

    const account = this.getAccount(user)

    return {
      id,
      first_name,
      last_name,
      email,
      merchant,
      permission: this.getPermission(user, account),
      account: account,
      role: account?.role.key,
      phone: phone || '-',
      document_number: documentNumber || '-',
      created_at: dateFormat(created_at, 'date'),
      updated_at: dateFormat(updated_at, 'date')
    }
  }

  /**
   *
   * @param {*} dataDefault
   * @returns
   */
  adapter (dataDefault) {
    return dataDefault.map(invite => {
      return this.convertToView(invite)
    })
  }

  /**
   * Executes all the methods
   * @returns Array
   */
  get () {
    return this.adapter(this.data)
  }

  /**
   * Executes all the methods and get first item
   * @returns Array
   */
  getOne () {
    if (!this.data.length) throw new Error('Missing argument data!')
    return this.get()[0]
  }
}

export default UsersManager
